export const TOP_MENU_HEIGHT = 45; // don't change this
export const LEFT_MENU_WIDTH = 85; // don't change this
